import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import VueCookies from 'vue-cookies'

import AuthLayout from '../layouts/AuthLayout.vue'
import AppLayout from '../layouts/AppLayout.vue'

import { ACCESS_TOKEN } from '../constants'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: 'dashboard' },
  },
  {
    name: 'admin',
    path: '/',
    component: AppLayout,
    meta: { isAuth: true },
    redirect: { name: 'login' },
    children: [
      {
        name: 'dashboard',
        path: 'dashboard',
        meta: { isAuth: true },
        component: () => import('../pages/admin/dashboard/main/Dashboard.vue'),
      },
      {
        path: 'user/:id',
        name: 'user',
        meta: { isAuth: true },
        component: () => import('../pages/admin/dashboard/main/[id].vue'),
      },
      {
        name: 'orders',
        path: 'orders',
        meta: { isAuth: true },
        component: () => import('../pages/admin/dashboard/orders/Orders.vue'),
      },
      {
        path: 'order/:id',
        name: 'order',
        meta: { isAuth: true },
        component: () => import('../pages/admin/dashboard/orders/[id].vue'),
      },
      {
        name: 'payments',
        path: 'payments',
        meta: { isAuth: true },
        component: () => import('../pages/admin/dashboard/Payments.vue'),
      },
      {
        name: 'contacts',
        path: 'contacts',
        meta: { isAuth: true },
        component: () => import('../pages/admin/dashboard/contacts/Contact.vue'),
      },
      {
        path: 'contact/:id',
        name: 'contact',
        meta: { isAuth: true },
        component: () => import('../pages/admin/dashboard/contacts/[id].vue'),
      },
      {
        path: 'emails',
        name: 'emails',
        meta: { isAuth: true },
        component: () => import('../pages/admin/dashboard/email/Email.vue'),
      },
      {
        path: 'categories',
        name: 'categories',
        meta: { isAuth: true },
        component: () => import('../pages/admin/dashboard/categories/Categories.vue'),
      },
      {
        path: 'products',
        name: 'products',
        meta: { isAuth: true },
        component: () => import('../pages/admin/dashboard/products/Products.vue'),
      },
      {
        path: 'product/:id',
        name: 'product',
        meta: { isAuth: true },
        component: () => import('../pages/admin/dashboard/products/[id].vue'),
      },
      {
        path: 'payment-methods',
        name: 'payment-methods',
        meta: { isAuth: true },
        component: () => import('../pages/admin/dashboard/payment-methods/PaymentMethods.vue'),
      },
      {
        path: 'prepayment-configs',
        name: 'prepayment-configs',
        meta: { isAuth: true },
        component: () => import('../pages/admin/dashboard/prepayment-configs/PrepaymentConfigs.vue'),
      },
    ],
  },
  {
    path: '/auth',
    component: AuthLayout,
    children: [
      {
        name: 'login',
        path: 'login',
        component: () => import('../pages/auth/Login.vue'),
      },
      {
        path: '',
        redirect: { name: 'login' },
      },
    ],
  },
  {
    name: '404',
    path: '/404',
    component: () => import('../pages/404.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    // For some reason using documentation example doesn't scroll on page navigation.
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' }
    } else {
      window.scrollTo(0, 0)
    }
  },
  routes,
})

router.beforeEach((to, from, next) => {
  const token = VueCookies.get(ACCESS_TOKEN)

  if (to.meta.isAuth && !token) {
    return next({ name: 'login' })
  }

  if (to.name === 'login' && token) {
    return next({ name: 'dashboard' })
  }

  next()
})

export default router
